import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'EUR') {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: currency,
  }).format(amount);
}

// The one listing price formatter: keyed on the listing's transaction_type,
// never on the user's mode. A rental carries "/mês"; a missing type is a sale.
export function formatListingPrice(price, transactionType) {
  if (!(Number(price) > 0)) return '—';
  const amount = new Intl.NumberFormat('pt-PT', { maximumFractionDigits: 0 }).format(price);
  return `${amount} €${transactionType === 'rent' ? '/mês' : ''}`;
}

export function formatDate(dateString) {
  return new Intl.DateTimeFormat('pt-PT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(dateString));
}

export function formatRelativeTime(dateString) {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    if (diffInSeconds < 0) return 'Agora';
    if (diffInSeconds < 60) return 'Agora mesmo';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} min atrás`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} h atrás`;
    if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)} dias atrás`;
    
    return formatDate(dateString);
  } catch (e) {
    return '';
  }
}

export function getQualificationLabel(qualification) {
  const labels = {
    basic: 'Básico',
    qualified: 'Qualificado',
    financing_approved: 'Financiamento Aprovado',
  };
  return labels[qualification] || qualification;
}

export function getQualificationColor(qualification) {
  const colors = {
    basic: 'bg-slate-100 text-slate-700',
    qualified: 'bg-amber-100 text-amber-700',
    financing_approved: 'bg-[var(--mid-secondary-muted)] text-[var(--mid-secondary-dark)]',
  };
  return colors[qualification] || 'bg-slate-100 text-slate-700';
}

export function getTimelineLabel(timeline) {
  const labels = {
    imediato: 'Imediato',
    '3meses': 'Até 3 meses',
    '6meses': 'Até 6 meses',
    '1ano': 'Até 1 ano',
    flexivel: 'Flexível',
  };
  return labels[timeline] || timeline;
}

export function getPropertyTypeLabel(type) {
  const labels = {
    apartment: 'Apartamento',
    house: 'Moradia',
    townhouse: 'Moradia em Banda',
    land: 'Terreno',
    commercial: 'Comercial',
    office: 'Escritório',
  };
  return labels[type] || type;
}
